<template>
  <v-container fluid style="margin: 0px">
    <v-card
      elevation="0"
      style="
        margin-top: 0px !important;
        margin-bottom: -30px !important;
        overflow: hidden;
        background-color: transparent;
      "
      class="px-5 py-1"
    >
      <v-row
        class="custom-gray-background fill-width d-flex"
        v-if="mostrarFiltro"
      >
        <v-col cols="12" sm="6" md="3">
          <span>Filtrar por</span>
          <v-select
            v-model="selectMode"
            :items="modos"
            label="Filtrar"
            dense
            solo-inverted
          ></v-select>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Data Inicial</span>
          <v-menu
            v-model="isStartDatePickerOpen"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template #activator="{ on }">
              <v-text-field
                v-model="selectedStartDate"
                label="Data Inicial"
                dense
                solo-inverted
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              v-model="localSelectedStartDateISO"
              @input="handleStartDateSelection"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Data Final</span>
          <v-menu
            v-model="isEndDatePickerOpen"
            :close-on-content-click="false"
            transition="scale-transition"
            offset-y
          >
            <template #activator="{ on }">
              <v-text-field
                v-model="selectedEndDate"
                label="Data Final"
                dense
                solo-inverted
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker
              no-title
              v-model="localSelectedEndDateISO"
              @input="handleEndDateSelection"
            ></v-date-picker>
          </v-menu>
        </v-col>

        <v-col cols="12" sm="6" md="4">
          <span>Empresa</span>
          <v-select
            v-model="selectedCompany"
            @input="handleEmpresaSelection"
            multiple
            :items="filteredEmpresas"
            label="Empresa"
            required
            dense
            solo-inverted
          >
          </v-select>
        </v-col>

        <v-col cols="12" sm="6" md="3">
          <span>Tipo</span>
          <v-select
            v-model="selectedType"
            :items="tipos"
            label="Tipo"
            dense
            solo-inverted
          ></v-select>
        </v-col>
      </v-row>

      <v-divider></v-divider>

      <v-card-actions class="justify-end">
        <v-btn
          @click="alternarVisibilidade"
          color="#4682B4"
          small
          class="mr-2"
          style="font-size: 14px !important; font-weight: bold"
        >
          {{ mostrarFiltro ? "Ocultar Filtro" : "Mostrar Filtro" }}
          <v-icon style="margin-left: 8px" dark>{{
            mostrarFiltro ? "mdi-eye-off" : "mdi-eye"
          }}</v-icon>
        </v-btn>

        <v-btn
          @click="limparFiltro"
          v-if="mostrarFiltro"
          color="#4682B4"
          small
          outlined
          class="mr-2"
          style="font-size: 14px !important; font-weight: bold"
        >
          Limpar
        </v-btn>
        <v-btn
          @click="filtrar"
          v-if="mostrarFiltro"
          color="#4682B4"
          small
          style="font-size: 14px !important; font-weight: bold"
        >
          Filtrar <v-icon style="margin-left: 8px" dark>mdi-filter</v-icon>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
export default {
  props: {
    modos: Array,
    tipos: Array,
    produtos: Array,
  },

  created() {
    if (this.modos.length > 0) {
      this.selectMode = this.modos[0];
    }

    if (this.tipos.length > 0) {
      this.selectedType = this.tipos[0];
    }


    this.selectedStartDate = this.getFirstDayOfMonth();
    this.selectedEndDate = this.formatDateBR(new Date());
  },

  data() {
    return {
      mostrarFiltro: true,
      localSelectedEndDateISO: "",
      localSelectedStartDateISO: "",

      selectedStartDateISO: "",
      selectedEndDateISO: "",

      selectedStartDate: "123",
      selectedEndDate: "",

      isStartDatePickerOpen: false,
      isEndDatePickerOpen: false,

      empresa: "Todas",
      selectedCompany: [""],
      selectedType: "",
      selectMode: "",

      empresas: [
        "CEMITERIO PREVIDA",
        "CEMITERIO PREVIDA SÃO MIGUEL",
        "MEMORIAL PARQUE MACEIÓ",
        "PARQUE DAS FLORES",
        "PARQUE DO AGRESTE",
        "PREVIDA",
        "Todas",
      ],
    };
  },

  computed: {
    filteredEmpresas() {
      // Filtra as empresas com base nos papéis do usuário
      return this.empresas.filter((empresa) => this.hasPermission(empresa));
    },
  },

  methods: {
    alternarVisibilidade() {
      this.mostrarFiltro = !this.mostrarFiltro;
    },

    filtrar() {
      if (
        !this.selectedCompany ||
        this.selectedCompany.length === 0 ||
        (this.selectedCompany.length === 1 && this.selectedCompany[0] === "")
      ) {
        // Se não houver empresa selecionada, emitir evento para mostrar o diálogo de erro
        this.$emit("showError");
        return;
      }

      // Se houver empresa selecionada, emitir o evento de filtrar normalmente
      this.$emit("filtrar", {
        selectedCompany: this.selectedCompany,
        selectMode: this.selectMode,
        selectedStartDate: this.selectedStartDate,
        selectedEndDate: this.selectedEndDate,
        selectedType: this.selectedType,
        selectedProduto: this.selectedProduto,
      });
    },

    limparFiltro() {
      this.empresa = "Todas";
      this.selectedCompany = ["Todas"];
      this.selectedType = "Todos";
      this.selectedProduto = "Todos";

      if (this.modos.length > 0) {
        this.selectMode = this.modos[0];
      }

      if (this.tipos.length > 0) {
        this.selectedType = this.tipos[0];
      }

      if (this.produtos.length > 0) {
        this.selectedProduto = this.produtos[0];
      }

      this.selectedStartDate = this.getFirstDayOfMonth();
      this.selectedEndDate = this.formatDateBR(new Date());
    },

    handleStartDateSelection() {
      this.selectedStartDate = this.convertToBR(this.localSelectedStartDateISO);
      this.isStartDatePickerOpen = false;
    },

    handleEndDateSelection() {
      this.selectedEndDate = this.convertToBR(this.localSelectedEndDateISO);
      this.isEndDatePickerOpen = false;
    },

    convertToISO(dateString) {
      // Converte a data do formato "20/10/2023" para "2023-10-20"
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    },

    convertToBR(dateString) {
      // Converte a data do formato ISO "2023-10-20" para "20/10/2023"
      const [year, month, day] = dateString.split("-");
      return `${day}/${month}/${year}`;
    },

    handleEmpresaSelection() {
      if (this.selectedCompany.includes("Todas")) {
        // Se "Todas" estiver selecionada, desabilita as outras opções
        this.selectedCompany = ["Todas"];
      }
    },

    hasPermission(empresa) {
      this.user = JSON.parse(sessionStorage.getItem("user"));

      if (this.user.roles.includes("ROLE_ADMIN")) {
        return true;
      } else if (empresa === "Todas") {
        return true;
      } else {
        const requiredRoles = empresa
          .split(",")
          .map(
            (name) => "ROLE_" + name.trim().toUpperCase().replace(/\s/g, "_")
          );

        const hasAnyRequiredRole = requiredRoles.some((role) =>
          this.user.roles.includes(role)
        );
        return hasAnyRequiredRole;
      }
    },

    getFirstDayOfMonth() {
      const dataAtual = new Date();
      const primeiroDiaDoMes = new Date(
        dataAtual.getFullYear(),
        dataAtual.getMonth(),
        1
      );
      return this.formatDateBR(primeiroDiaDoMes);
    },

    formatDateBR(date) {
      if (!date) return "";
      const parsedDate = new Date(date);
      const day = String(parsedDate.getDate()).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const month = String(parsedDate.getMonth() + 1).padStart(2, "0"); // Adiciona zero à esquerda, se necessário
      const year = parsedDate.getFullYear();
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
<style>
/* Certifique-se de que o arquivo CSS com a classe .custom-col esteja importado aqui */
.custom-col-13 {
  flex-basis: 13%; /* 15% é equivalente a 1.5 colunas em uma grade de 10 colunas */
  max-width: 13%;
}
.custom-col-15 {
  flex-basis: 15%; /* 15% é equivalente a 1.5 colunas em uma grade de 10 colunas */
  max-width: 15%;
}
</style>
